import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { UserRole, hasPermission, ROLE_LABELS } from "../types/church";

const AdminRoute = ({ children, requiredRole = UserRole.PASTOR, allowedRoles }) => {
  const { currentUser, churchUser, loading } = useAuth();

  // Resolve key string (e.g. "SEGUNDO_SECRETARIO") to UserRole value (e.g. "Segundo_Secretario")
  const resolvedRole = UserRole[requiredRole] || requiredRole;

  // Resolve allowedRoles keys to values
  const resolvedAllowedRoles = allowedRoles
    ? allowedRoles.map((r) => UserRole[r] || r)
    : null;

  if (loading) {
    return (
      <div className="min-vh-100 bg-background d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!churchUser) {
    return (
      <div className="min-vh-100 bg-background d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  // If allowedRoles is provided, check explicit list; otherwise use hierarchy
  const temPermissao = resolvedAllowedRoles
    ? resolvedAllowedRoles.includes(churchUser.role)
    : hasPermission(churchUser.role, resolvedRole);

  if (!temPermissao) {
    return (
      <div className="min-vh-100 bg-background d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="mb-4">
            <i className="fas fa-lock fa-3x text-muted"></i>
          </div>
          <h4 className="text-muted">Acesso Restrito</h4>
          <p className="text-muted mb-4">
            Esta área requer permissão de {ROLE_LABELS[resolvedRole] || resolvedRole} ou superior.
          </p>
          <a href="/dashboard" className="btn btn-primary">
            Voltar ao Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
